module.exports = __webpack_public_path__ + "img/oasis-4.e0ffc67b.png";